import { NgModule } from '@angular/core';
import {SharedModule} from './app/shared/shared.module';
import {rootScopeProvider} from 'ib-web-commons/utils';
import { DatalayerUtilsProvider } from 'ib-web-commons/ib-datalayer';
import { IbMainFooterModule } from './components/ib-main-footer/ib-main-footer.module';
const importExport = [IbMainFooterModule];
@NgModule({
    declarations: [],
    exports: [...importExport],
    imports: [
        SharedModule,
        ...importExport
    ],
    providers: [
        rootScopeProvider,
        DatalayerUtilsProvider
    ]
})
export class IbMenusAppModule {}
